import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import inviteCardM1 from 'assets/InviteCards/card_m1.jpg';
import inviteCardM2 from 'assets/InviteCards/card_m2.jpg';
import inviteCardM2b from 'assets/InviteCards/card_m2b.jpg';
import inviteCardM3 from 'assets/InviteCards/card_m3.jpg';
import inviteCardM3b from 'assets/InviteCards/card_m3b.jpg';
import inviteCardS1 from 'assets/InviteCards/card_s1.jpg';
import inviteCardS2 from 'assets/InviteCards/card_s2.jpg';
import inviteCardS2b from 'assets/InviteCards/card_s2b.jpg';
import inviteCardS3 from 'assets/InviteCards/card_s3.jpg';
import inviteCardS3b from 'assets/InviteCards/card_s3b.jpg';
const inviteCards = {
    m1: inviteCardM1,
    m2: inviteCardM2,
    m2b: inviteCardM2b,
    m3: inviteCardM3,
    m3b: inviteCardM3b,
    s1: inviteCardS1,
    s2: inviteCardS2,
    s2b: inviteCardS2b,
    s3: inviteCardS3,
    s3b: inviteCardS3b,
};
export function useInviteCard(defaultImage) {
    const location = useLocation();
    const query = queryString.parse(location.search);
    const inviteCardId = String(query.c || '');
    return inviteCards[inviteCardId] || defaultImage;
}
export default useInviteCard;
